import { Injectable } from '@angular/core';
import { Product } from '../../../models/product.model';
import { CartItem } from '../../cart/model/cart-item-model';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { ToastyService } from 'ng2-toasty';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import { API } from './api.service';
import * as _ from 'lodash';
import { MessagesServices } from './systemmessages.service';
@Injectable()
export class CartService {
  public cart$: Observable<Array<CartItem>>;
  private errorArray: Array<any> = [];
  private _cartObserver: any;
  private _cartStore: {
    cart: Array<CartItem>
  };
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  msg2: any = '';
  title2: any = '';
  msg3: any = '';
  title3: any = '';
  msg4: any = '';
  title4: any = '';
  msg5: any = '';
  title5: any = '';
  msg6: any = '';
  title6: any = '';
  constructor(private api: API, private toastyService: ToastyService, private sm: MessagesServices) {
    this.createCartObserver();
    this.getMessages();
  }
  getMessages() {
    // this.sm.getSystemMessages().subscribe(data => {
      this.messages = this.sm.messags;
     if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_ALREADY_OWN_THIS_SONG') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_LICENSES_CANNOT_BE_BLANK') {
          this.title2 = this.messages[i].title;
          this.msg2 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_REQUEST_CANNOT_BE_ENTERTAINED') {
          this.title3 = this.messages[i].title;
          this.msg3 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_ADDED_TO_CART') {
          this.title4 = this.messages[i].title;
          this.msg4 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_REMOVED_FROM_THE_CART') {
          this.title5 = this.messages[i].title;
          this.msg5 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_ALREADY_IN_THE_CART') {
          this.title6 = this.messages[i].title;
          this.msg6 = this.messages[i].message;
        }
      }
    }
  }

  /**
  * getting system messages
  **/
  setMessages() {
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_ALREADY_OWN_THIS_SONG') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_LICENSES_CANNOT_BE_BLANK') {
          this.title2 = this.messages[i].title;
          this.msg2 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_REQUEST_CANNOT_BE_ENTERTAINED') {
          this.title3 = this.messages[i].title;
          this.msg3 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_ADDED_TO_CART') {
          this.title4 = this.messages[i].title;
          this.msg4 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_REMOVED_FROM_THE_CART') {
          this.title5 = this.messages[i].title;
          this.msg5 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_ALREADY_IN_THE_CART') {
          this.title6 = this.messages[i].title;
          this.msg6 = this.messages[i].message;
        }
      }
    }
  }

  createCartObserver() {
    this._cartStore = { cart: [] };
    this.cart$ = new Observable((observer: any) => {
      this._cartObserver = observer;
    }).share();
  }

  getCart() {

    this.api.post('cart/load-cart', {}).subscribe(data => {
      this._cartStore.cart = data;
      if(this._cartObserver != null){
        this._cartObserver.next(this._cartStore.cart.slice(0));
      }

    });
  }

  /*
  * Filtering if item is not already added and than adding to stack...
  */
  filterAndAddToStack(cartItem,multi=1) {
    if (!_.find(this._cartStore.cart, function (item) { return item.song_id === cartItem.song_id; })) {
      this._cartStore.cart.push(cartItem);
      this._cartObserver.next(this._cartStore.cart.slice(0));
      if(multi==1)
      this.handleSuccess("added");
    } else {
      if(multi==1)
      this.handleSuccess("Already_added_to_cart");
    }

  }

  addItem(product: any,multi=1) {

    // this.setMessages();
    let that = this;
    if(product.available_for_download) {
        this.api.post('cart/add-to-cart', {song_id: product.id}).subscribe(res => {
            if (res.item.product) {
                this.filterAndAddToStack(res.item, multi);
            }
        }, function (err) {
            that.handleErrors(err);
        });
    }else{
        if(multi==1)
            this.handleSuccess("available_for_download");
    }
  }


  removeItem(cartItem: CartItem) {
    console.log('item', cartItem);
    // this.setMessages();
    this.api.post('cart/remove-item', { id: cartItem.id }).subscribe(() => {
      this._cartStore.cart = this._cartStore.cart.filter(item => cartItem.id !== item.id);
      this._cartObserver.next(this._cartStore.cart.slice(0));
    });
    this.handleSuccess("removed");
  }

  flushCart() {
    this.api.get('cart/empty-cart').subscribe(()=>{
    })
    this._cartStore.cart = [];
    this._cartObserver.next(this._cartStore.cart.slice(0));
  }

  cartTotals(qty = 0, total = 0) {
    this._cartStore.cart.forEach(cartItem => {
      qty += cartItem.qty;
      total += cartItem.qty * cartItem.price;
    });
    return { qty, total };
  }

  /**
   * if successfully add or removed item from cart
   */
  handleSuccess(action: string) {
    if (action == "available_for_download") {
      let toastOptions = {
        title: "",
        msg: "Some playlist songs are not available for download.",
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.toastyService.success(toastOptions);
    }

    if (action == "added") {
      var toastOptions = {
        title: this.title4,
        msg: this.msg4,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.toastyService.success(toastOptions);
    }
    if (action == "Already_added_to_cart") {
      var toastOptions = {
        title: this.title6,
        msg: this.msg6,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.toastyService.error(toastOptions);
    }
    if (action == "removed") {
      var toastOptions = {
        title: this.title5,
        msg: this.msg5,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.toastyService.success(toastOptions);
    }
  }

  handleErrors(err) {
    console.log(err);
    if (err.status === 500) {
      var toastOptions = {
        title: this.title3,
        msg: this.msg3,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.toastyService.error(toastOptions);
      return;
    }
    this.errorArray = [];
    var validationErrors = JSON.parse(err._body);
    if (err._body) {
      // for (var index = 0; index < validationErrors.length; index++) {
      let toastOptions = {
        title: this.title1,
        msg: this.msg1,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.errorArray[validationErrors[0].field] = this.msg1;
      this.toastyService.error(toastOptions);
      let toastOptions2 = {
        title: this.title2,
        msg: this.msg2,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.errorArray[validationErrors[1].field] = this.msg2;
      this.toastyService.error(toastOptions2);
      // }
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/api/services/cart.service.ts